import React from 'react'
import { Legend } from '@devexpress/dx-react-chart-material-ui'
import { withStyles } from '@material-ui/core/styles'

const legendStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '65px'
  }
})
const legendRootBase = ({ classes, ...restProps }) => {
  return <Legend.Root {...restProps} className={classes.root} />
}

const Root = withStyles(legendStyles, { name: 'LegendRoot' })(legendRootBase)
const legendLabelStyles = () => ({
  label: {
    whiteSpace: 'nowrap',
    transform: 'rotate(-90deg) translate(-100%)',
    '& > span': {
      fontFamily: 'National',
      fontSize: '10px',
      fontWeight: 500,
      letterSpacing: '2px',
      lineHeight: '13px',
      color: '#8688A1'
    }
  }
})

const legendLabelBase = ({ classes, ...restProps }) => <Legend.Label className={classes.label} {...restProps} text='QUARTILE' />
const Label = withStyles(legendLabelStyles, { name: 'LegendLabel' })(legendLabelBase)
const Marker = () => null

const ValueAxisLegend = () => <Legend position='left' rootComponent={Root} labelComponent={Label} markerComponent={Marker} />

export default ValueAxisLegend
